import React from 'react';
import { Row } from '@amzn/atoz-web/Row';
import { Col } from '@amzn/atoz-web/Col';
import { ShiftIntervalBlock } from './ShiftIntervalBlock';
import { useShiftIntervalListData } from './utils';
export var ShiftIntervalList = function (_a) {
    var shiftIntervals = _a.shiftIntervals, filterWorkIntervals = _a.filterWorkIntervals, hideIntervalSkill = _a.hideIntervalSkill;
    var sortedDesiredShiftIntervals = useShiftIntervalListData({
        shiftIntervals: shiftIntervals,
        filterWorkIntervals: filterWorkIntervals,
        hideIntervalSkill: hideIntervalSkill
    });
    if (sortedDesiredShiftIntervals.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Col, { dataTestId: "ShiftIntervalList", gridGap: "S200", margin: { top: 'S200', bottom: 'S200' }, role: "list" }, sortedDesiredShiftIntervals.map(function (_a) {
        var category = _a.category, name = _a.name, timeRange = _a.timeRange, skill = _a.skill;
        return (React.createElement(Row, { key: "ShiftInterval-".concat(category, "-").concat(timeRange.start, "-").concat(timeRange.end) },
            React.createElement(ShiftIntervalBlock, { category: category, name: name, timeRange: timeRange, skill: skill })));
    })));
};
